
import PropTypes from "prop-types"
import { Button, Box } from "@mui/material";
import Iconify from "../../../../../reusable-components/iconify";

MobileDrawerIndicator.propTypes = {
  setIsTicketInfoOpen: PropTypes.func
}
export default function MobileDrawerIndicator({setIsTicketInfoOpen}) {
  return <Button
      variant="outlined"
      color="secondary"
      sx={{
        writingMode: 'vertical-rl',
        fontSize: '12px',
        backgroundColor: '#ffff',
        position: 'absolute', 
        top: '50%',
        transform: 'translateY(-50%)',
        right: 6,
        padding: 1,
        minWidth: 0,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
      }}
      onClick={() => setIsTicketInfoOpen(true)}
    >
      Ticket Information
      <Iconify icon={'mdi:chevron-left'} />
    </Button>
}